module.exports = __webpack_public_path__ + "img/430x590px.62e9b724.png";